import { jaroWinkler } from "helpers/jaroWinkler";

/** Shared cutoff for import and bulk-update column suggestion. */
export const JARO_WINKLER_MATCH_THRESHOLD = 0.9;

const normalizeColumnName = (value: string) => value.trim().toLowerCase();

export const getColumnMatchScore = (fileColumn: string, candidates: string[]) => {
    const normalizedFileColumn = normalizeColumnName(fileColumn);
    const scores = candidates
        .filter((candidate) => candidate.trim() !== "")
        .map((candidate) => jaroWinkler(normalizedFileColumn, normalizeColumnName(candidate)));

    if (scores.length === 0) return 0;
    return Math.max(...scores);
};
